import WebFont from 'webfontloader'; //****** To-do, test loading in the families first asynchronously from check whether to load the url if necessary ******//

var familes = ['BrandFont-Text', 'BrandFont-Display'];
var FontConfig = {
  loaded: false,
  loadingFonts: []
}; //Turn on or off the font loader

function setFontLoaded(loaded) {
  FontConfig.loaded = loaded ? true : false;
}

function checkFontLoaded() {
  return FontConfig.loaded;
} // Define and Load the fonts


var customConfig = {
  families: familes
};
var fontUri1 = 'https://respframework.verizon.com/fonts/v2/fonts-update.css';
var fontUri2 = 'https://respframework.verizon.com/fonts/v2/fonts.css';
var fontUri3 = 'https://respframework.verizon.com/fonts/eText/verizon-nhg-etx-update.css';

function finishLoading() {
  var WebFontConfig = {
    custom: customConfig,
    timeout: 10,
    // default 3000
    active: function active() {
      setFontLoaded(true);
    },
    inactive: function inactive() {
      console.warn('fonts could not be loaded.');
    }
  };
  WebFont.load(WebFontConfig);
}

function checkIfLoaded() {
  var sheetRefs = document.styleSheets;
  var sheetsArray = sheetRefs && Object.values(sheetRefs);
  return sheetsArray.find(function (styleSheet) {
    return styleSheet.href === fontUri1 || styleSheet.href === fontUri2 || styleSheet.href === fontUri3;
  });
}

function loadFonts() {
  if (checkFontLoaded()) return;
  var loaded = checkIfLoaded();

  if (!loaded) {
    customConfig.urls = [fontUri1];
    finishLoading(customConfig);
  } else setFontLoaded(true);
}

function addMetaTags() {
  var link1 = document.createElement('meta');
  link1.setAttribute('http-equiv', 'Cache-Control');
  link1.content = 'no-cache, no-store, must-revalidate';
  var link2 = document.createElement('meta');
  link2.setAttribute('http-equiv', 'Pragma');
  link2.content = 'no-cache';
  var link3 = document.createElement('meta');
  link3.setAttribute('http-equiv', 'Expires');
  link3.content = '0';
  [(link1, link2, link3)].forEach(function (link) {
    return document.getElementsByTagName('head')[0].appendChild(link);
  });
}

addMetaTags();
if (checkIfLoaded()) setFontLoaded(true);
export var Fonts = {
  NeueHaasGroteskText: 'BrandFont-Text',
  // BAU - Text Normal
  NeueHaasGroteskDisplay: 'BrandFont-Display',
  // BAU - Text Display,
  checkFontLoaded: checkFontLoaded,
  setFontLoaded: setFontLoaded,
  loadFonts: loadFonts
};